
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexe8vFNWa146nPoYZQPN9lpwvHCrVGENQaIjoRSbR7T4sMeta } from "/app/apps/dashboard/src/pages/index.vue?macro=true";
import { default as my_45profile5_9Sc1OdFtcJwOHbI1Zn5zUqxfxz6XU0X7sL7Iglf94Meta } from "/app/apps/dashboard/src/pages/my-profile.vue?macro=true";
import { default as return_45urlrgfBY0n_k5o0G_WBEa3Wl7Ygg9uAXg8DwmMe9vRcVBoMeta } from "/app/apps/dashboard/src/pages/return-url.vue?macro=true";
import { default as mainoLczuSHcEuDVx7_NHEKEQWrSGysozwt2TDPnfco4KrcMeta } from "/app/apps/dashboard/src/pages/invitation/main.vue?macro=true";
import { default as librarym2kfMKQ3KpAWQqiSsu4JIxKv8jnVmHWUHqFn0qICTQ4Meta } from "/app/apps/dashboard/src/pages/teacher/library.vue?macro=true";
import { default as dashboardNzMOm5XHxBtUo4p9FD6WbbLauKUG9fhZ2R_AEmAAaZwMeta } from "/app/apps/dashboard/src/pages/parent/dashboard.vue?macro=true";
import { default as trainingGaNT7DjwyaCcive4F55CwLkzTj5lprDUW0sZt_NRzrAMeta } from "/app/apps/dashboard/src/pages/teacher/training.vue?macro=true";
import { default as dashboard32ykQ_8egUSWBOaJq6JvDyDVl2_9SL6OCcIxdtmJGYgMeta } from "/app/apps/dashboard/src/pages/learner/dashboard.vue?macro=true";
import { default as dashboardZ7RYBcgm8Mh6O_DbAT3F5pSnVg__zSBqfgh61xWYszgMeta } from "/app/apps/dashboard/src/pages/teacher/dashboard.vue?macro=true";
import { default as successaC_Sba9DZh4LjTMdA_RGfVNVL_HiORBgF2bXoLMA92oMeta } from "/app/apps/dashboard/src/pages/invitation/success.vue?macro=true";
import { default as createChildfxNnAGE9EHtZPoZthCi4cC6edG4Yv1gvMOxAPpCwH2EMeta } from "/app/apps/dashboard/src/pages/parent/createChild.vue?macro=true";
import { default as setupschoolRR8Vaq1USQB__uGOFc6kTSM9ZrB_WNlpfBvevo_Yeh8Meta } from "/app/apps/dashboard/src/pages/teacher/setupschool.vue?macro=true";
import { default as classFulluXTRBebvq9nWwokCI3tmGkIeof8_wrax0jq4bfnhNHMMeta } from "/app/apps/dashboard/src/pages/invitation/classFull.vue?macro=true";
import { default as create_45classpVfkeMidFwQ6k3qdOAgO0x_ln12eVflg3xJ9vgZQC40Meta } from "/app/apps/dashboard/src/pages/teacher/create-class.vue?macro=true";
import { default as inviteSuccessXwK158s0V111InaYBW526Hu_vdQinm_4fh03oy_K8NYMeta } from "/app/apps/dashboard/src/pages/invitation/inviteSuccess.vue?macro=true";
import { default as mainHBeWUmTZaYQbI_pjgCB_4qmLQPb9GjZcndTaXW0Gss4Meta } from "/app/apps/dashboard/src/pages/learner/startlearning/main.vue?macro=true";
import { default as _91userId_93_nCAySY4CH8VjvZAiIwOap2gZwabS2tfkKWBQE1AaPEMeta } from "/app/apps/dashboard/src/pages/parent/join-class/[userId].vue?macro=true";
import { default as indexOPF9OA22dALM4wM7gBH3m8TnIEUbVKFPrH_TNpvTO74Meta } from "/app/apps/dashboard/src/pages/teacher/account-setup/index.vue?macro=true";
import { default as downloadsEmow2IjNZdyObEZrQqaGv_dxGiv57fJKgbFNHCuicugMeta } from "/app/apps/dashboard/src/pages/desktop-installers/downloads.vue?macro=true";
import { default as addClasst3Lb__FtJbjYt0YwN_ITBKljpGIN5nMHtHgR0MftrhIMeta } from "/app/apps/dashboard/src/pages/learner/startlearning/addClass.vue?macro=true";
import { default as _91userId_939pfgoRO4xA3wHanPGsAhoxtpYhxxNwuiRWzAXgrzwZwMeta } from "/app/apps/dashboard/src/pages/parent/activateMaterial/[userId].vue?macro=true";
import { default as _91userId_93uQs7lc0LdFb8qHuv8ghMRnlGC0SUN8HeZjdywI_2FMQMeta } from "/app/apps/dashboard/src/pages/parent/editChildProfile/[userId].vue?macro=true";
import { default as _91userId_93P4CGyg_lVX9FXWG_VBZPZ4shzbkI4TXcA4Lcrcn32ecMeta } from "/app/apps/dashboard/src/pages/parent/viewChildDetails/[userId].vue?macro=true";
import { default as joinSchoolT7air_h4RRty651ezZ1hpPawWqegeJ8YVpaf_AfV_eQMeta } from "/app/apps/dashboard/src/pages/teacher/startteaching/joinSchool.vue?macro=true";
import { default as _91userId_93ZCj1xnox70XMaNEjyCrwTx1dkNrb9WJH_MX61uQBOZQMeta } from "/app/apps/dashboard/src/pages/parent/resetChildPassword/[userId].vue?macro=true";
import { default as viewvnnFttjQT_5XhIkFYgPQ7DXswSQfou6pCUgqHMAiMboMeta } from "/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/view.vue?macro=true";
import { default as classUYGWbKyW_4J1g8DkkD_lZpPjmy1tLPdPAyBXbVIMAdoMeta } from "/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/class.vue?macro=true";
import { default as indexF7P7J0IRu017QbMthJtSGn5sCDdy9SoG0soSXuhfk6oMeta } from "/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/index.vue?macro=true";
import { default as independentteacherWFlJfgi1NohqpPScqkBuTHF5xRjR_ebKPUvPfN4LKdsMeta } from "/app/apps/dashboard/src/pages/teacher/startteaching/independentteacher.vue?macro=true";
import { default as joinSchoolOptionsxzOR2Zyz4QVswNZ1J7bpxazBeSCzPHMm81MvQCAX9hMMeta } from "/app/apps/dashboard/src/pages/teacher/account-setup/step/joinSchoolOptions.vue?macro=true";
import { default as _91_91class_93_93Ya1jy7wvY_03e7EOp6eUYjs4CLPUWci_oaaCPgfaSw8Meta } from "/app/apps/dashboard/src/pages/learner/[school]/resourcebank/[code]/[[class]].vue?macro=true";
import { default as _91_91class_93_93JfirkJxXQPunWkAxpwxEwnMD5fUVWPhv8WCGmU8qb14Meta } from "/app/apps/dashboard/src/pages/teacher/[school]/resourcebank/[code]/[[class]].vue?macro=true";
import { default as _91umbrellaCode_930RRvUM9TIzO15B3ke4vKYMOBEKJpvnUajD9g5DANbKsMeta } from "/app/apps/dashboard/src/pages/teacher/freetrial/questionnaire/[umbrellaCode].vue?macro=true";
import { default as _91_91class_93_93XtCY8CZtGG9Ow7D5H1CE80NB59__lDolhPeY3r_bBRgMeta } from "/app/apps/dashboard/src/pages/learner/[school]/externalresources/[code]/[[class]].vue?macro=true";
import { default as _91app_93NZot7pm7tZdsG77s3gbrhiTYnXA6nrnJ0BeYMTwXJkkMeta } from "/app/apps/dashboard/src/pages/teacher/[school]/activateMaterial/[learnerId]/[app].vue?macro=true";
import { default as _91_91class_93_93UA57iT8cD3MxNOQedjp4N_i6i7X2FEgl6V2xTMbwem8Meta } from "/app/apps/dashboard/src/pages/teacher/[school]/externalresources/[code]/[[class]].vue?macro=true";
import { default as coming_45soonipmGH7v3SA2PM8gOw4bmQOXKqxiWQq7aChG3ugZ4QWsMeta } from "/app/apps/dashboard/src/pages/[school]/bundle/[code]/product/[product-code]/coming-soon.vue?macro=true";
import { default as _91component_45code_93gldBsqJ6tn6iLanf48l_BwOiiL_LH5rOBtOvn3m1yEIMeta } from "/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/digital-component/[component-code].vue?macro=true";
import { default as acceptTmooc1qxfJmBKXgKtDohll9Af0zQZc1SM26gDKeZ6DQMeta } from "/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/accept.vue?macro=true";
import { default as coming_45soonu6zPLH1MCoxXj0Xgrod9gcVvxB8yd1QoX2W9T9o88VUMeta } from "/app/apps/dashboard/src/pages/[school]/class/[class-id]/bundle/[code]/product/[product-code]/coming-soon.vue?macro=true";
import { default as ReviewProfilerEfPtI90LQDybsfaGaiv2Gq5aqQQ9YwnMo_Mn_3vUPAMeta } from "/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/ReviewProfile.vue?macro=true";
import { default as teacherInvitechuNvumo12HfQmmC27PbzVbQwaEsKcV8NX1yGTQepOcMeta } from "/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/teacherInvite.vue?macro=true";
import { default as _91component_45code_9316B0yy_PxmU42Gamm08g439coypGFPtm86r84ylqBHgMeta } from "/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/class/[class-id]/digital-component/[component-code].vue?macro=true";
import { default as _91scheduleType_93yWHn2zTbTVCASBlzKsGpJeFT2oAjEFibULM_R9Xiem0Meta } from "/app/apps/dashboard/src/pages/learner/[school]/class/[class]/product/[component]/content-access/[rule]/[scheduleType].vue?macro=true";
import { default as component_45stubffWvKOIjJhaGEiRyIETvr2cAK4gtLfmk7jrg1jNyBCYMeta } from "/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@24.10.7_@vue+compiler-sfc@3.5.13_cac@6.7.1_b9b3c333d7db46a7ef4be30188054340/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubffWvKOIjJhaGEiRyIETvr2cAK4gtLfmk7jrg1jNyBCY } from "/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@24.10.7_@vue+compiler-sfc@3.5.13_cac@6.7.1_b9b3c333d7db46a7ef4be30188054340/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/dashboard/src/pages/index.vue")
  },
  {
    name: "my-profile",
    path: "/my-profile",
    meta: my_45profile5_9Sc1OdFtcJwOHbI1Zn5zUqxfxz6XU0X7sL7Iglf94Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/my-profile.vue")
  },
  {
    name: "return-url",
    path: "/return-url",
    component: () => import("/app/apps/dashboard/src/pages/return-url.vue")
  },
  {
    name: "invitation-main",
    path: "/invitation/main",
    meta: { ...(mainoLczuSHcEuDVx7_NHEKEQWrSGysozwt2TDPnfco4KrcMeta || {}), ...{"middleware":["block-parent-child-access"]} },
    component: () => import("/app/apps/dashboard/src/pages/invitation/main.vue")
  },
  {
    name: "teacher-library",
    path: "/teacher/library",
    meta: { ...(librarym2kfMKQ3KpAWQqiSsu4JIxKv8jnVmHWUHqFn0qICTQ4Meta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/library.vue")
  },
  {
    name: "parent-dashboard",
    path: "/parent/dashboard",
    meta: { ...(dashboardNzMOm5XHxBtUo4p9FD6WbbLauKUG9fhZ2R_AEmAAaZwMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/parent/dashboard.vue")
  },
  {
    name: "teacher-training",
    path: "/teacher/training",
    meta: { ...(trainingGaNT7DjwyaCcive4F55CwLkzTj5lprDUW0sZt_NRzrAMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/training.vue")
  },
  {
    name: "learner-dashboard",
    path: "/learner/dashboard",
    meta: { ...(dashboard32ykQ_8egUSWBOaJq6JvDyDVl2_9SL6OCcIxdtmJGYgMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/dashboard.vue")
  },
  {
    name: "teacher-dashboard",
    path: "/teacher/dashboard",
    meta: { ...(dashboardZ7RYBcgm8Mh6O_DbAT3F5pSnVg__zSBqfgh61xWYszgMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/dashboard.vue")
  },
  {
    name: "invitation-success",
    path: "/invitation/success",
    meta: {"middleware":["block-parent-child-access"]},
    component: () => import("/app/apps/dashboard/src/pages/invitation/success.vue")
  },
  {
    name: "parent-createChild",
    path: "/parent/createChild",
    meta: { ...(createChildfxNnAGE9EHtZPoZthCi4cC6edG4Yv1gvMOxAPpCwH2EMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/parent/createChild.vue")
  },
  {
    name: "teacher-setupschool",
    path: "/teacher/setupschool",
    meta: setupschoolRR8Vaq1USQB__uGOFc6kTSM9ZrB_WNlpfBvevo_Yeh8Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/setupschool.vue")
  },
  {
    name: "invitation-classFull",
    path: "/invitation/classFull",
    meta: { ...(classFulluXTRBebvq9nWwokCI3tmGkIeof8_wrax0jq4bfnhNHMMeta || {}), ...{"middleware":["block-parent-child-access"]} },
    component: () => import("/app/apps/dashboard/src/pages/invitation/classFull.vue")
  },
  {
    name: "teacher-create-class",
    path: "/teacher/create-class",
    meta: { ...(create_45classpVfkeMidFwQ6k3qdOAgO0x_ln12eVflg3xJ9vgZQC40Meta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/create-class.vue")
  },
  {
    name: "invitation-inviteSuccess",
    path: "/invitation/inviteSuccess",
    meta: { ...(inviteSuccessXwK158s0V111InaYBW526Hu_vdQinm_4fh03oy_K8NYMeta || {}), ...{"middleware":["block-parent-child-access"]} },
    component: () => import("/app/apps/dashboard/src/pages/invitation/inviteSuccess.vue")
  },
  {
    name: "learner-startlearning-main",
    path: "/learner/startlearning/main",
    meta: { ...(mainHBeWUmTZaYQbI_pjgCB_4qmLQPb9GjZcndTaXW0Gss4Meta || {}), ...{"middleware":["authorisation-role-based","check-add-material"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/main.vue")
  },
  {
    name: "parent-join-class-userId",
    path: "/parent/join-class/:userId()",
    meta: { ...(_91userId_93_nCAySY4CH8VjvZAiIwOap2gZwabS2tfkKWBQE1AaPEMeta || {}), ...{"middleware":["authorisation-role-based","load-child-details"]} },
    component: () => import("/app/apps/dashboard/src/pages/parent/join-class/[userId].vue")
  },
  {
    name: "teacher-account-setup",
    path: "/teacher/account-setup",
    meta: { ...(indexOPF9OA22dALM4wM7gBH3m8TnIEUbVKFPrH_TNpvTO74Meta || {}), ...{"middleware":["start-teaching"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/account-setup/index.vue")
  },
  {
    name: "desktop-installers-downloads",
    path: "/desktop-installers/downloads",
    meta: downloadsEmow2IjNZdyObEZrQqaGv_dxGiv57fJKgbFNHCuicugMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/desktop-installers/downloads.vue")
  },
  {
    name: "learner-startlearning-addClass",
    path: "/learner/startlearning/addClass",
    meta: { ...(addClasst3Lb__FtJbjYt0YwN_ITBKljpGIN5nMHtHgR0MftrhIMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/addClass.vue")
  },
  {
    name: "parent-activateMaterial-userId",
    path: "/parent/activateMaterial/:userId()",
    meta: { ...(_91userId_939pfgoRO4xA3wHanPGsAhoxtpYhxxNwuiRWzAXgrzwZwMeta || {}), ...{"middleware":["authorisation-role-based","load-child-details"]} },
    component: () => import("/app/apps/dashboard/src/pages/parent/activateMaterial/[userId].vue")
  },
  {
    name: "parent-editChildProfile-userId",
    path: "/parent/editChildProfile/:userId()",
    meta: { ...(_91userId_93uQs7lc0LdFb8qHuv8ghMRnlGC0SUN8HeZjdywI_2FMQMeta || {}), ...{"middleware":["authorisation-role-based","load-child-details"]} },
    component: () => import("/app/apps/dashboard/src/pages/parent/editChildProfile/[userId].vue")
  },
  {
    name: "parent-viewChildDetails-userId",
    path: "/parent/viewChildDetails/:userId()",
    meta: { ...(_91userId_93P4CGyg_lVX9FXWG_VBZPZ4shzbkI4TXcA4Lcrcn32ecMeta || {}), ...{"middleware":["authorisation-role-based","load-child-details"]} },
    component: () => import("/app/apps/dashboard/src/pages/parent/viewChildDetails/[userId].vue")
  },
  {
    name: "teacher-startteaching-joinSchool",
    path: "/teacher/startteaching/joinSchool",
    meta: { ...(joinSchoolT7air_h4RRty651ezZ1hpPawWqegeJ8YVpaf_AfV_eQMeta || {}), ...{"middleware":["authorisation-role-based","start-teaching"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/startteaching/joinSchool.vue")
  },
  {
    name: "parent-resetChildPassword-userId",
    path: "/parent/resetChildPassword/:userId()",
    meta: { ...(_91userId_93ZCj1xnox70XMaNEjyCrwTx1dkNrb9WJH_MX61uQBOZQMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/parent/resetChildPassword/[userId].vue")
  },
  {
    name: "teacher-school-bundle-code-view",
    path: "/teacher/:school()/bundle/:code()/view",
    meta: viewvnnFttjQT_5XhIkFYgPQ7DXswSQfou6pCUgqHMAiMboMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/view.vue")
  },
  {
    name: "learner-startlearning-addMaterial-class",
    path: "/learner/startlearning/addMaterial/class",
    meta: { ...(classUYGWbKyW_4J1g8DkkD_lZpPjmy1tLPdPAyBXbVIMAdoMeta || {}), ...{"middleware":["check-add-material"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/class.vue")
  },
  {
    name: "learner-startlearning-addMaterial",
    path: "/learner/startlearning/addMaterial",
    meta: { ...(indexF7P7J0IRu017QbMthJtSGn5sCDdy9SoG0soSXuhfk6oMeta || {}), ...{"middleware":["authorisation-role-based","check-add-material"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/index.vue")
  },
  {
    name: "teacher-startteaching-independentteacher",
    path: "/teacher/startteaching/independentteacher",
    meta: { ...(independentteacherWFlJfgi1NohqpPScqkBuTHF5xRjR_ebKPUvPfN4LKdsMeta || {}), ...{"middleware":["start-teaching"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/startteaching/independentteacher.vue")
  },
  {
    name: "teacher-account-setup-step-joinSchoolOptions",
    path: "/teacher/account-setup/step/joinSchoolOptions",
    meta: { ...(joinSchoolOptionsxzOR2Zyz4QVswNZ1J7bpxazBeSCzPHMm81MvQCAX9hMMeta || {}), ...{"middleware":["start-teaching"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/account-setup/step/joinSchoolOptions.vue")
  },
  {
    name: "learner-school-resourcebank-code-class",
    path: "/learner/:school()/resourcebank/:code()/:class?",
    meta: { ...(_91_91class_93_93Ya1jy7wvY_03e7EOp6eUYjs4CLPUWci_oaaCPgfaSw8Meta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/[school]/resourcebank/[code]/[[class]].vue")
  },
  {
    name: "teacher-school-resourcebank-code-class",
    path: "/teacher/:school()/resourcebank/:code()/:class?",
    meta: { ...(_91_91class_93_93JfirkJxXQPunWkAxpwxEwnMD5fUVWPhv8WCGmU8qb14Meta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/resourcebank/[code]/[[class]].vue")
  },
  {
    name: "teacher-freetrial-questionnaire-umbrellaCode",
    path: "/teacher/freetrial/questionnaire/:umbrellaCode()",
    meta: _91umbrellaCode_930RRvUM9TIzO15B3ke4vKYMOBEKJpvnUajD9g5DANbKsMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/freetrial/questionnaire/[umbrellaCode].vue")
  },
  {
    name: "learner-school-externalresources-code-class",
    path: "/learner/:school()/externalresources/:code()/:class?",
    meta: { ...(_91_91class_93_93XtCY8CZtGG9Ow7D5H1CE80NB59__lDolhPeY3r_bBRgMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/[school]/externalresources/[code]/[[class]].vue")
  },
  {
    name: "teacher-school-activateMaterial-learnerId-app",
    path: "/teacher/:school()/activateMaterial/:learnerId()/:app()",
    meta: _91app_93NZot7pm7tZdsG77s3gbrhiTYnXA6nrnJ0BeYMTwXJkkMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/activateMaterial/[learnerId]/[app].vue")
  },
  {
    name: "teacher-school-externalresources-code-class",
    path: "/teacher/:school()/externalresources/:code()/:class?",
    meta: { ...(_91_91class_93_93UA57iT8cD3MxNOQedjp4N_i6i7X2FEgl6V2xTMbwem8Meta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/externalresources/[code]/[[class]].vue")
  },
  {
    name: "school-bundle-code-product-productcode-coming-soon",
    path: "/:school()/bundle/:code()/product/:productcode()/coming-soon",
    meta: coming_45soonipmGH7v3SA2PM8gOw4bmQOXKqxiWQq7aChG3ugZ4QWsMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/[school]/bundle/[code]/product/[product-code]/coming-soon.vue")
  },
  {
    name: "teacher-school-bundle-code-digital-component-componentcode",
    path: "/teacher/:school()/bundle/:code()/digital-component/:componentcode()",
    meta: { ...(_91component_45code_93gldBsqJ6tn6iLanf48l_BwOiiL_LH5rOBtOvn3m1yEIMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/digital-component/[component-code].vue")
  },
  {
    name: "invitation-schoolId-class_enrollment-classId-invitationId-accept",
    path: "/invitation/:schoolId()/class_enrollment/:classId()/:invitationId()/accept",
    meta: {"middleware":["block-parent-child-access"]},
    component: () => import("/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/accept.vue")
  },
  {
    name: "school-class-classid-bundle-code-product-productcode-coming-soon",
    path: "/:school()/class/:classid()/bundle/:code()/product/:productcode()/coming-soon",
    meta: coming_45soonu6zPLH1MCoxXj0Xgrod9gcVvxB8yd1QoX2W9T9o88VUMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/[school]/class/[class-id]/bundle/[code]/product/[product-code]/coming-soon.vue")
  },
  {
    name: "invitation-schoolId-class_enrollment-classId-invitationId-ReviewProfile",
    path: "/invitation/:schoolId()/class_enrollment/:classId()/:invitationId()/ReviewProfile",
    meta: { ...(ReviewProfilerEfPtI90LQDybsfaGaiv2Gq5aqQQ9YwnMo_Mn_3vUPAMeta || {}), ...{"middleware":["block-parent-child-access"]} },
    component: () => import("/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/ReviewProfile.vue")
  },
  {
    name: "invitation-schoolId-class_enrollment-classId-invitationId-teacherInvite",
    path: "/invitation/:schoolId()/class_enrollment/:classId()/:invitationId()/teacherInvite",
    meta: { ...(teacherInvitechuNvumo12HfQmmC27PbzVbQwaEsKcV8NX1yGTQepOcMeta || {}), ...{"middleware":["block-parent-child-access"]} },
    component: () => import("/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/teacherInvite.vue")
  },
  {
    name: "teacher-school-bundle-code-class-classid-digital-component-componentcode",
    path: "/teacher/:school()/bundle/:code()/class/:classid()/digital-component/:componentcode()",
    meta: { ...(_91component_45code_9316B0yy_PxmU42Gamm08g439coypGFPtm86r84ylqBHgMeta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/class/[class-id]/digital-component/[component-code].vue")
  },
  {
    name: "learner-school-class-class-product-component-content-access-rule-scheduleType",
    path: "/learner/:school()/class/:class()/product/:component()/content-access/:rule()/:scheduleType()",
    meta: { ...(_91scheduleType_93yWHn2zTbTVCASBlzKsGpJeFT2oAjEFibULM_R9Xiem0Meta || {}), ...{"middleware":["authorisation-role-based"]} },
    component: () => import("/app/apps/dashboard/src/pages/learner/[school]/class/[class]/product/[component]/content-access/[rule]/[scheduleType].vue")
  },
  {
    name: component_45stubffWvKOIjJhaGEiRyIETvr2cAK4gtLfmk7jrg1jNyBCYMeta?.name,
    path: "/status",
    component: component_45stubffWvKOIjJhaGEiRyIETvr2cAK4gtLfmk7jrg1jNyBCY
  }
]